import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { TextField, SingleFilePickerField } from '../../components'
import { Button } from '../../elements'

import validate from './validate'

class ClientRegisterForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
  }

  render() {
    const { isSubmiting, handleSubmit, onSubmit } = this.props

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Field
          name="clientId"
          label="Client Id"
          disabled={isSubmiting}
          component={TextField}
        />
        <Field
          name="displayName"
          label="Client Name"
          disabled={isSubmiting}
          component={TextField}
        />
        <Button loading={isSubmiting} htmlType="submit" type="primary">Create</Button>
      </form>
    )
  }
}

export default reduxForm({
  form: 'client-register',
  validate,
})(ClientRegisterForm)



// WEBPACK FOOTER //
// ./src/smart-components/client-register-form/index.js